export default __webpack_public_path__ + "static/media/fl1.903cf2f8.jpg";